import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="border-t bg-background">
      <div className="container flex flex-col gap-8 py-8 md:flex-row md:py-12">
        <div className="flex-1">
          <div className="font-bold">Crucar - the data engine for automotive aftermarket</div>
          <p className="mt-2 text-sm text-muted-foreground">
            Crucar doesn't just provide data – we provide clarity.
            <br /><br />
            Maintain your competitive edge, with our tailored solutions, designed to meet your unique needs and challenges. Our goal is to transform your data from a passive asset into an active force for innovation and growth.
          </p>
        </div>
        <div className="flex flex-1 flex-col items-center md:items-end">
          <div className="grid grid-cols-2 gap-8 sm:grid-cols-2">
            <div className="space-y-3">
              <h4 className="text-sm font-medium">Company</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/about" className="text-muted-foreground hover:text-foreground">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-muted-foreground hover:text-foreground">
                    Contact
                  </Link>
                </li>
                <li>
                  <Link to="/pricing" className="text-muted-foreground hover:text-foreground">
                    Pricing
                  </Link>
                </li>
              </ul>
            </div>
            <div className="space-y-3">
              <h4 className="text-sm font-medium">Legal</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/privacy" className="text-muted-foreground hover:text-foreground">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms" className="text-muted-foreground hover:text-foreground">
                    Terms of Service
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t">
        <div className="container flex flex-col gap-4 py-6 text-center text-sm text-muted-foreground md:flex-row md:justify-between">
          <p>© 2024 Crucar - the data engine for automotive aftermarket. All rights reserved.</p>
          <p>Built with ❤️ & 🧠 for a better shopping experience</p>
        </div>
      </div>
    </footer>
  );
};